import React from "react";
import { useTranslation } from "react-i18next";
import { WeekDays as SharedWeekDays } from "@sophy/shared-ui";

/** The shared seven days with this app's day names and screen-reader labels. */
export function WeekDays(props) {
  const { t } = useTranslation();
  const dayLabels = Array.from({ length: 7 }, (_, index) => t(`gamification.days.${index}`));
  return (
    <SharedWeekDays
      {...props}
      dayLabels={dayLabels}
      doneLabel={t("gamification.week.day_done")}
      openLabel={t("gamification.week.day_open")}
    />
  );
}

export default WeekDays;
